<template>
  <page>
    <page-poster
      :headline="$t('contacts.poster.headline')"
      :paragraphs="[$t('contacts.poster.paragraph')]"
      :class="$style['contacts-poster']"
    />
    <div :class="$style['container']">
      <contacts-form />
      <contacts-find-us />
    </div>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePoster from '@/components/common/PagePoster.vue';
import ContactsForm from '@/components/contacts/ContactsForm.vue';
import ContactsFindUs from '@/components/contacts/ContactsFindUs.vue';

export default {
  components: {
    Page,
    PagePoster,
    ContactsForm,
    ContactsFindUs,
  },
}
</script>

<style lang="scss" module>
.contacts-poster {
  padding-bottom: 75px;

  p {
    max-width: 590px;
    text-align: center;
  }
}
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 100px;
}
</style>
